import { IconButton } from '@mui/material';
import React from 'react';

import { CenterCellContainer } from './CenterCellContainer';

export const CellIconButton = ({ icon, onClick, href }: { icon: React.ReactNode, onClick?: () => void, href?: string }) => {
  return (
    <CenterCellContainer>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          if (onClick) {
            onClick();
          }
        }}
        href={href}
        target={href ? '_blank' : undefined}
        size='small'
        color='primary'
        sx={{
          '&:hover': {
            color: (theme) => theme.palette.grey[600],
          },
        }}
      >
        {icon}
      </IconButton>
    </CenterCellContainer>
  );
};
